import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import _ from "lodash";
import axios from 'axios';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker'
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import {
    getDDMMYYYY,
    getDDMMYYYYHHMMSS,
    getYYYYMMDD,
    getYYYYMMDDHHMMSS,
    getHyphenYYYYMMDDHHMMSS,
    getHyphenYYYYMMDD,
    getHyphenDDMMMYYYYHHMM, getHyphenDDMMMYYYY,
    getHyphenDDMMYYYYHHMMSS,
    getHyphenDDMMYYYY,
    getDecoder
} from '../common/utils';
import Select from 'react-select';
import $ from 'jquery';
// import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/datepicker';
import redirectURL from "../redirectURL";
import TransitLineChart from './transitdashboardlinechart.js';
import ColumnGroupTransit from './columngrouptransitchart.js';
import DonutChartWithDrilldown from './donutChart.js';
// var googleAnalytics = require("../common/googleanalytics");


export default class TransitData extends Component {

    constructor(props) {
        super(props);
        this.state = {
            defaultColDef: {
                sortable: true,
                filter: true,
                resizable: true,
                enablePivot: true,
                pivot: true,
                // enableValue: true,
                enableRowGroup: true,
            },
            sideBar: {
                toolPanels: [
                    {
                        id: "columns",
                        labelDefault: "Columns",
                        labelKey: "columns",
                        iconKey: "columns",
                        toolPanel: "agColumnsToolPanel"
                    },
                    {
                        id: "filters",
                        labelDefault: "Filters",
                        labelKey: "filters",
                        iconKey: "filter",
                        toolPanel: "agFiltersToolPanel"
                    }
                ]
            },
            rowData: [],
            rowDataExcluded: [],
            paginationPageSize: 50,
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: "agTotalAndFilteredRowCountComponent",
                        align: "left"
                    },
                    {
                        statusPanel: "agTotalRowCountComponent",
                        align: "center"
                    },
                    { statusPanel: "agFilteredRowCountComponent" },
                    { statusPanel: "agSelectedRowCountComponent" },
                    { statusPanel: "agAggregationComponent" }
                ]
            },
            locations: [],
            transporters: [],
            transporter: { value: "all", label: "All" },
            location: { value: "all", label: "All" },
            dept_code: '',
            departmentarray: [],
            scatterdepartmentarray: [],
            categories: [],
            scattercategories: [],
            transporterdata: [],
            transdrilldown: [],
            transportergpsdata: [],
            transgpsdrilldown: [],
            showtranschart: 'show-m',
            showgpschart: 'show-n',
            loadcheck: true,
            gpsloadcheck: false,
            loadshow: 'show-n',
            overly: 'show-n',
            endDate: new Date(moment.parseZone()),
            startDate: new Date(moment.parseZone().subtract(1, "month")),
            tripclosureallsummary: [],
            tripclosureprimarysummary: [],
            tripclosuresecondsummary: [],
            tripcategories: [],
            tripfcclosureallsummary: [],
            tripfcclosureprimarysummary: [],
            tripfcclosuresecondsummary: [],
            tripfccategories: [],
            monthlydataaall: [],
            monthlyprimarydata: [],
            monthlysecondarydata: [],
            shownormalprimary: 'show-n',
            shownormalall: 'show-m',
            shownormalsecond: 'show-n',
            showfcprimary: 'show-n',
            showfcsecond: 'show-n',
            showfcall: 'show-m',
            pchecked: false,
            schecked: false,
            achecked: true,
            afcchecked: false,
            sfcchecked: false,
            afcchecked: true,
            monthlyfcprimarydata: [],
            monthlyfcsecondarydata: [],
            monthlyfcalldata: [],
            dept_code: '',
            defaultsdate: '',
            defaultedate: '',
            usergridstate: [],
            user: getDecoder(),
            screenurl: "",
            screentitle: "",
            pagetitle: "Transits Analytics",
            eventGridAction: "gridAction",

        }
    }

    loadData() {
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m'
            // transporter: { "value": "all", "label": 'All' },
            // location: { "value": "all", "label": 'All' }
        });
        var edate = moment.parseZone(this.state.endDate).utcOffset("+05:30").format("YYYY-MM-DD");
        var sdate = moment.parseZone(this.state.startDate).utcOffset("+05:30").format("YYYY-MM-DD");;

        var preqparams = {
            dept_code: "SNDG"
        }
        if (this.state.user.role[0] == "PLANT") {
            preqparams["plant_codes"] = this.state.user.plant_codes ?? "EMPTY"
        }
        redirectURL.get("/consignments/getConsigner",  { params: preqparams })
            .then((response) => {
                var records = response.data.records;
                var locations = [];
                if (records.length > 0) {
                    records.map((item) => {
                        locations.push({
                            code: item.value,
                            label: item.label
                        })
                    })
                }
                this.setState({
                    locations: locations
                })
            })
            .catch(function (e) {
                console.log("Error ", e)
            })

        redirectURL.post("/consignments/transportersbydept", {
            deptcode: "SNDG"
        })
            .then((response) => {
                var records = response.data;
                var transporters = [];
                if (records.length > 0) {
                    records.map((item) => {
                        transporters.push({
                            code: item.transporter_code,
                            label: item.transporter_name + " (" + item.transporter_code + ")",
                        })
                    })
                }
                this.setState({
                    transporters: transporters
                })
            })
            .catch(function (e) {
                console.log("Error ", e)
            });
        let params = {
            dept_code: "SNDG",
            startDate: sdate,
            endDate: edate,
            transporter: Array.isArray(this.state.transporter)?this.state.transporter: [this.state.transporter]  ?? [{ "value": "all", "label": 'All' }],
            location: Array.isArray(this.state.location)?this.state.location:[this.state.location] ??[{ "value": "all", "label": 'All' }]
        }
        if (this.state.user.role[0] == "PLANT") {
            params["location"] = this.state.user.plant_codes.map(e => { return { label: e, value: e } }) ?? "EMPTY"
        }

        redirectURL.post("/dashboard/transitdashboarddata", params)
            .then((response) => {
                var tripclosuresummarydata = JSON.parse(response.data.trip_type_closure_counts)
                var tripfcclosuresummary = JSON.parse(response.data.trip_type_fc_reason_counts)
                let monthlydataaallarr = []

                const monthclosurereport = sortMonthYear(JSON.parse(response.data.monthly_trip_type_closure_counts))
                const groupedData = monthclosurereport.reduce((result, item) => {
                    // Create the year and month group key
                    // const key = `${item.invoice_year} ${item.invoice_month}`;
                    const key = item.trip_closure_type;
                    // Initialize the group if not already created
                    if (!result[key]) {
                        result[key] = [];
                    }
                    // Push the item into the correct group
                    result[key].push(item);
                    return result;
                }, {});
                const monthCat = Array.from(new Set(monthclosurereport.map(e => e.invoice_gate_out_month + " " + e.invoice_gate_out_year)))
                const monthDRparr = []
                for (const category in groupedData) {
                    const data = []
                    monthCat.forEach(e => {
                        let temp = groupedData[category].find(itm => ((itm.invoice_gate_out_month + " " + itm.invoice_gate_out_year) == e))
                        if (temp)
                            data.push(temp.All ?? 0)
                        else
                            data.push(0)
                    })
                    monthDRparr.push({
                        name: category,
                        data
                    })
                }
                monthlydataaallarr.push({
                    categories: monthCat,
                    lineseries: monthDRparr
                })

                /*Monthly Force Closuer Chart*/

                const monthlyforceclosesum = sortMonthYear(JSON.parse(response.data.monthly_trip_type_fc_reason_counts))
                const groupedData2 = monthlyforceclosesum.reduce((result, item) => {
                    // Create the year and month group key
                    // const key = `${item.invoice_year} ${item.invoice_month}`;
                    const key = item.force_closure_reason;
                    // Initialize the group if not already created
                    if (!result[key]) {
                        result[key] = [];
                    }
                    // Push the item into the correct group
                    result[key].push(item);
                    return result;
                }, {});
                const monthCat2 = Array.from(new Set(monthlyforceclosesum.map(e => e.invoice_gate_out_month + " " + e.invoice_gate_out_year)))
                const monthFCRparr = []
                for (const category in groupedData2) {
                    const data = []
                    monthCat2.forEach(e => {
                        let temp = groupedData2[category].find(itm => ((itm.invoice_gate_out_month + " " + itm.invoice_gate_out_year) == e))
                        if (temp)
                            data.push(temp.All ?? 0)
                        else
                            data.push(0)
                    })
                    monthFCRparr.push({
                        name: category,
                        data
                    })
                }
                let fcmonthlydataallarr = []
                fcmonthlydataallarr.push({
                    categories: monthCat2,
                    lineseries: monthFCRparr
                })

                var tripclosureallsummary = []
                var categories = []
                var totalallrr = 0
                var allarr = []

                categories.push("Total");
                allarr.push(0)
                tripclosuresummarydata.forEach((item, key) => {
                    categories.push(item.trip_closure_type)
                    totalallrr = totalallrr + parseInt(item.All)
                    allarr.push(item.All)
                })
                tripclosureallsummary.push({
                    series: [{
                        name: "Total",
                        data: [totalallrr]
                    }, {
                        name: "All",
                        data: allarr
                    }],
                    categories: categories
                })

                /*Trip Type Force Close Reasons */

                var tripfcclosureallsummary = []
                var tripfcclosuresummarydataarr = [];
                var fccategories = []
                var fcallarr = []
                var fctotl = []
                var fctotalallrr = 0
                fccategories.push("Total");
                tripfcclosuresummary.forEach((item, key) => {
                    fccategories.push(item.force_closure_reason)
                    fctotalallrr = fctotalallrr + parseInt(item.All)
                    fcallarr.push({
                        name: item.force_closure_reason,
                        y: item.All
                    })
                    fctotl.push(item.Primary + item.Secondary)
                    tripfcclosuresummarydataarr.push({
                        name: item.trip_closure_type,
                        data: [item.Primary, item.Secondary]
                    })
                })
                tripfcclosureallsummary.push({
                    series: [
                        {
                            name: "Count",
                            data: fcallarr
                        }],
                    categories: fccategories
                })
                this.setState({
                    tripclosureallsummary: tripclosureallsummary,
                    tripfcclosureallsummary: tripfcclosureallsummary,
                    monthlydataaall: monthlydataaallarr,
                    monthlyfcalldata: fcmonthlydataallarr,
                    loadshow: 'show-n',
                    overly: 'show-n',
                });
            })
            .catch(function (e) {
                console.log("Error ", e)
            })

        this.setState({
            dept_code: "SNDG",
            startDate: sdate,
            endDate: edate,
            defaultsdate: sdate,
            defaultedate: edate,
            locations: [],
            transporters: []
        })
    }

    componentDidMount() {
        this.loadData()
    }

    onSelectLocation = location => {
        this.setState(
            { location },
            () => console.log(`Location Option selected:`, this.state.location)
        );

        this.setState({
            errorMessage: '',
            successMessage: ''
        })
    }
    onSelectTransporter = transporter => {
        this.setState(
            { transporter },
            () => console.log(`Transporter Option selected:`, this.state.transporter)
        );

        this.setState({
            errorMessage: '',
            successMessage: ''
        })
    }
    locationoptions() {
        var items = [];
        // console.log("locations ",this.props.locations)
        var locations = this.state.locations;
        //console.log("locations ",locations)
        if (locations.length > 0) {
            items.push({ value: 'all', label: 'All' });
            locations.forEach(item => {
                items.push({ value: item.code, label: item.label });
            });
        }
        //console.log("Locas ", items)
        return items;
    }
    transporteroptions() {
        var items = []
        var transporters = this.state.transporters;
        items.push({ value: 'all', label: 'All' });
        if (transporters.length > 0) {
            transporters.forEach(item => {
                items.push({ value: item.code, label: item.label });
            })
        }
        //console.log("Transps ", items)
        return items;
    }

    handleStartDateChange = (date) => {
        if (this.state.endDate && date > this.state.endDate) {
            this.setState({
                show: true,
                basicTitle: 'To Date should be greater than From Date',
                basicType: "danger",
                loadshow: 'show-n'
            });
        } else {
            this.setState({ startDate: date });
        }
    };

    handleEndDateChange = (date) => {
        if (this.state.startDate && date < this.state.startDate) {
            this.setState({
                show: true,
                basicTitle: 'To Date should be greater than From Date',
                basicType: "danger",
                loadshow: 'show-n'
            });
        } else {
            this.setState({ endDate: date });
        }
    };
    onClickGetLoadingData(event) {
        event.preventDefault();
        this.setState({
            loadshow: 'show-m',
            overly: "show-m"
        })
        this.loadData()
    }


    onGridReady = params => {
        this.gridApi = params.api;

        //console.log("Grid is: ", params);
        this.gridColumnApi = params.columnApi;

        //    ChartMenu.prototype.saveChart = function (e) {
        // 	   var event = {
        // 	      data: this.gridOptionsWrapper.getApi(),
        // 	      type: ChartMenu.EVENT_DOWNLOAD_CHART
        // 	    };
        // 	   //console.log("Testing", event);
        // 	  // console.log("hart Cell Ranges : ", event.data.chartService.rangeController.cellRanges)
        // 	   this.dispatchEvent(event);
        // 	   var chrtdata = event.data.chartService.rangeController.cellRanges;

        //    };


    };


    onGridState = () => {
        //console.log(this.gridApi);

        /*Get  Current Columns State and Store in this.colState */
        this.colState = this.gridColumnApi.getColumnState();

        /*Get Current RowGroup Columns State and Store in this.rowGroupState */
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

        /*Get Current Pivot Columns State and Store in this.pivotColumns, 
         * User should enable the Pivot mode.*/
        this.pivotColumns = this.gridColumnApi.getPivotColumns();

        /*Get Current Filter State and Store in window.filterState */
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);



    }

    onChangeChartView(params) {
        // if (googleAnalytics.page.enableGA) {
        //     let pageTitle = this.state.pagetitle;
        //     let eventOptions = {
        //         "category": pageTitle,
        //         "action": this.state.eventGridAction,
        //         "label": "Change Chart View",
        //     }
        //     googleAnalytics.logEvent(eventOptions);
        // }
        if (params == 'primary') {
            this.setState({
                pchecked: true,
                schecked: false,
                achecked: false,
                shownormalprimary: 'show-m',
                shownormalsecond: 'show-n',
                shownormalall: 'show-n'
            })
        }
        if (params == 'second') {
            this.setState({
                pchecked: false,
                schecked: true,
                achecked: false,
                shownormalprimary: 'show-n',
                shownormalsecond: 'show-m',
                shownormalall: 'show-n'
            })
        }
        if (params == 'all') {
            this.setState({
                pchecked: false,
                schecked: false,
                achecked: true,
                shownormalprimary: 'show-n',
                shownormalsecond: 'show-n',
                shownormalall: 'show-m'
            })
        }
    }
    onChangeFcChartView(parmas) {
        // if (googleAnalytics.page.enableGA) {
        //     let pageTitle = this.state.pagetitle;
        //     let eventOptions = {
        //         "category": pageTitle,
        //         "action": this.state.eventGridAction,
        //         "label": "Change Force Closure Chart View",
        //     }
        //     googleAnalytics.logEvent(eventOptions);
        // }
        if (parmas == 'primary') {
            this.setState({
                pfcchecked: true,
                sfcchecked: false,
                afcchecked: false,
                showfcprimary: 'show-m',
                showfcsecond: 'show-n',
                showfcall: 'show-n'
            })
        }
        if (parmas == 'second') {
            this.setState({
                pfcchecked: false,
                sfcchecked: true,
                afcchecked: false,
                showfcprimary: 'show-n',
                showfcsecond: 'show-m',
                showfcall: 'show-n'
            })
        }
        if (parmas == 'all') {
            this.setState({
                pfcchecked: false,
                sfcchecked: false,
                afcchecked: true,
                showfcprimary: 'show-n',
                showfcsecond: 'show-n',
                showfcall: 'show-m'
            })
        }
    }
    onClickHideAll() {
        this.setState({
            loadshow: 'show-n',
            overly: 'show-n',

        });

    }
    render() {

        return (
            <div className="col-xl-12 col-lg-12 mb-3">
                <div className={"row col-xl-12 col-lg-12 "}>
                    <ul className="dashboard-page">

                    </ul>
                </div>
                <h5 className="col-xl-12 col-lg-12">
                    <i className="icofont icofont-dashboard-web cus-i"></i> <span style={{ fontWeight: "600" }}>Transit Analytics</span>
                </h5>
                <div className={"col-xl-12 col-lg-12 tab- pt-2 pb-3 ml-18p whiteRow "}>
                    <div className="card-body n-p-0 mt-10p">


                        <div className="col-xl-12 col-lg-12">
                            <div className="row pt-20px tab-brd">
                                <div className="row col-xl-12 col-lg-12">
                                    <div className="form-group col-xl-2 col-lg-2">
                                        <label>Start Date </label>
                                        {/* <Datetime value={this.state.startDate}
                            disableCloseOnClickOutside={false}
                            closeOnSelect={true}
                            inputProps={{ readOnly: true, placeholder: 'Start Date', name: 'startDate', autoComplete: 'off', className: 'custom-datetime-input' }}
                            dateFormat="YYYY-MM-DD"
                            name="startDate"
                            timeFormat={false}
                            onChange={this.handlerStartDateTime.bind(this)}
                            isValidDate={current => {
                                return current.isSameOrBefore(moment(), 'day');
                            }} /> */}
                                        <DatePicker
                                            selected={this.state.startDate}
                                            dateFormat="dd/MM/yyyy"
                                            onChange={this.handleStartDateChange.bind(this)}
                                            name="startDate"
                                            className="datepicker-custom"
                                        />
                                    </div>
                                    <div className="form-group col-xl-2 col-lg-2">
                                        <label>End Date </label>
                                        {/* <Datetime value={this.state.endDate}
                            disableCloseOnClickOutside={false}
                            closeOnSelect={true}
                            timeFormat={false}
                            inputProps={{ placeholder: 'End Date', name: 'endDate', autoComplete: 'off', readOnly: true, className: 'custom-datetime-input' }}
                            dateFormat="YYYY-MM-DD"
                            name="endDate"
                            onChange={this.handlerEndDateTime.bind(this)}
                            isValidDate={current => {
                                return current.isSameOrAfter(moment(new Date(this.state.startDate)), 'day');
                            }} /> */}
                                        <DatePicker
                                            selected={this.state.endDate}
                                            onChange={this.handleEndDateChange.bind(this)}
                                            name="endDate"
                                            className="datepicker-custom"
                                            dateFormat="dd/MM/yyyy"
                                        />
                                    </div>
                                    <div className="form-gplantwiseloadingroup col-xl-3 col-lg-3">
                                        <label>Location </label>
                                        <Select placeholder={"All"} isMulti={true} value={this.state.location} className="border-radius-0" onChange={this.onSelectLocation.bind(this)} style={{ borderRadius: "0px" }} options={this.locationoptions()} required />
                                    </div>
                                    <div className="form-group col-xl-3 col-lg-3">
                                        <label>Transporter </label>
                                        <Select placeholder={"All"} isMulti={true} value={this.state.transporter} className="border-radius-0" onChange={this.onSelectTransporter.bind(this)} style={{ borderRadius: "0px" }} options={this.transporteroptions()} required />
                                    </div>
                                    <div className="form-group col-xl-2 col-lg-2">
                                        <label>&nbsp;</label><br />
                                        <button type="button" className="btn btn-success" onClick={this.onClickGetLoadingData.bind(this)}>Submit</button>
                                    </div>
                                </div>
                                <div className="row col-xl-12 col-lg-12">
                                    {/* <div className={"col-xl-12 col-lg-12 mt-40p optchrt"}>
                        <input type="radio" value="all" checked={this.state.achecked} onChange={this.onChangeChartView.bind(this, "all")} /> All
                        &nbsp;&nbsp;<input type="radio" value="primary" checked={this.state.pchecked} onChange={this.onChangeChartView.bind(this, "primary")} /> Primary
                        &nbsp;&nbsp;<input type="radio" value="second" checked={this.state.schecked} onChange={this.onChangeChartView.bind(this, "second")} /> Secondary
                    </div> */}
                                    <div className="row col-xl-12 col-lg-12 mb-40p pt-3 mt-3">
                                        {/* {(this.state.tripclosuresummary.length > 0 && typeof this.state.tripclosuresummary != 'undefined')? */}

                                        {/* //this.state.tripclosuresummary.map(item =>  */}
                                        <div className={"col-xl-6 col-lg-6 " + (this.state.shownormalall)}>
                                            {this.state.tripclosureallsummary.length > 0 ?
                                                this.state.tripclosureallsummary.map(item =>
                                                    <ColumnGroupTransit
                                                        title={"Trip Closure Summary (All)"}
                                                        subtitle={""}
                                                        context={this}
                                                        series={item.series}
                                                        //drildown = {item.chartdrildown}
                                                        categories={item.categories}
                                                        xaxistitle={"Closure Type"}
                                                        yaxistitle={"Consignments"}
                                                        dept_code={this.state.dept_code}
                                                    />
                                                )
                                                : ""}
                                        </div>
                                        {/* <div className={"col-xl-6 col-lg-6 " + (this.state.shownormalprimary)}>
                            {this.state.tripclosureprimarysummary.length > 0 ?

                                this.state.tripclosureprimarysummary.map(item =>
                                    <ColumnGroupTransit
                                        title={"Trip Closure Summary (Primary)"}
                                        subtitle={""}
                                        context={this}
                                        series={item.series}
                                        //drildown = {item.chartdrildown}
                                        categories={item.categories}
                                        xaxistitle={"Closure Type"}
                                        yaxistitle={"Consignments"}
                                        dept_code={this.state.dept_code}
                                    />
                                )
                                : ""}
                        </div>
                        <div className={"col-xl-6 col-lg-6 " + (this.state.shownormalsecond)}>
                            {this.state.tripclosuresecondsummary.length > 0 ?

                                this.state.tripclosuresecondsummary.map(item =>
                                    <ColumnGroupTransit
                                        title={"Trip Closure Summary (Secondary)"}
                                        subtitle={""}
                                        context={this}
                                        series={item.series}
                                        //drildown = {item.chartdrildown}
                                        categories={item.categories}
                                        xaxistitle={"Closure Type"}
                                        yaxistitle={"Consignments"}
                                        dept_code={this.state.dept_code}
                                    />
                                )
                                : ""}
                        </div> */}

                                        <div className={"col-xl-6 col-lg-6 "}>

                                            {this.state.monthlydataaall.length > 0 ?
                                                this.state.monthlydataaall.map(item =>
                                                    <div className={"col-xl-12 col-lg-12 row " + (this.state.shownormalall)}>

                                                        <TransitLineChart
                                                            title={"Monthly Trip Closure Summary (All)"}
                                                            subtitle={""}
                                                            context={this}
                                                            series={item.lineseries}
                                                            categories={item.categories}
                                                            xaxistitle={"Month-Year"}
                                                            yaxistitle={"Clouser type (%)"}
                                                            dept_code={this.state.dept_code}
                                                        />
                                                    </div>
                                                )
                                                : ""}
                                            {/* {this.state.monthlyprimarydata.length > 0 ?
                                this.state.monthlyprimarydata.map(item =>
                                    <div className={"col-xl-12 col-lg-12 row " + (this.state.shownormalprimary)}>

                                        <TransitLineChart
                                            title={"Monthly Trip Closure Summary (Primary)"}
                                            subtitle={""}
                                            context={this}
                                            series={item.lineseries}
                                            categories={item.categories}
                                            xaxistitle={"Month-Year"}
                                            yaxistitle={"Clouser type (%)"}
                                            dept_code={this.state.dept_code}
                                        />
                                    </div>
                                )
                                : ""}
                            {this.state.monthlysecondarydata.length > 0 ?
                                this.state.monthlysecondarydata.map(item =>
                                    <div className={"col-xl-12 col-lg-12 row " + (this.state.shownormalsecond)}>
                                        <TransitLineChart
                                            title={"Monthly Trip Closure Summary (Secondary)"}
                                            subtitle={""}
                                            context={this}
                                            series={item.lineseries}
                                            categories={item.categories}
                                            xaxistitle={"Month-Year"}
                                            yaxistitle={"Clouser type (%)"}
                                            dept_code={this.state.dept_code}
                                        />
                                    </div>
                                )
                                : ""} */}
                                        </div>

                                    </div>
                                    <div className="row col-xl-12 col-lg-12 mb-40p">
                                        <div className={"col-xl-6 col-lg-6 " + (this.state.shownormalall)}>
                                            {this.state.tripfcclosureallsummary.length > 0 ?
                                                this.state.tripfcclosureallsummary.map(item =>
                                                    <DonutChartWithDrilldown
                                                        title={"Force Closure Summary (All)"}
                                                        context={this}
                                                        series={item.series}
                                                        categories={item.categories}
                                                        xaxistitle={"Closure Reason"}
                                                        yaxistitle={"Consignments"}
                                                    />
                                                )
                                                : ""}
                                        </div>
                                        {/* <div className={"col-xl-6 col-lg-6 " + (this.state.shownormalprimary)}>
                            {this.state.tripfcclosureprimarysummary.length > 0 ?
                                this.state.tripfcclosureprimarysummary.map(item =>
                                    <ColumnGroupTransit
                                        title={"Force Closure Summary (Primary)"}
                                        subtitle={""}
                                        context={this}
                                        series={item.series}
                                        categories={item.categories}
                                        xaxistitle={"Closure Reason"}
                                        yaxistitle={"Consignments"}
                                        dept_code={this.state.dept_code}
                                    />
                                )
                                : ""}
                        </div> */}
                                        {/* <div className={"col-xl-6 col-lg-6 " + (this.state.shownormalsecond)}>
                            {this.state.tripfcclosuresecondsummary.length > 0 ?
                                this.state.tripfcclosuresecondsummary.map(item =>
                                    <ColumnGroupTransit
                                        title={"Force Closure Summary (Secondary)"}
                                        subtitle={""}
                                        context={this}
                                        series={item.series}
                                        categories={item.categories}
                                        xaxistitle={"Closure Reason"}
                                        yaxistitle={"Consignments"}
                                        dept_code={this.state.dept_code}
                                    />
                                )
                                : ""}
                        </div> */}
                                        <div className={"col-xl-6 col-lg-6 "}>
                                            {this.state.monthlyfcalldata.length > 0 ?
                                                this.state.monthlyfcalldata.map(item =>
                                                    <div className={"col-xl-12 col-lg-12 row " + (this.state.shownormalall)}>
                                                        <TransitLineChart
                                                            title={"Monthly Force Closure Summary (All)"}
                                                            subtitle={""}
                                                            context={this}
                                                            series={item.lineseries}
                                                            categories={item.categories}
                                                            xaxistitle={"Month-Year"}
                                                            yaxistitle={"Clouser type (%)"}
                                                            dept_code={this.state.dept_code}
                                                        />
                                                    </div>
                                                )
                                                : ""}
                                            {/* {this.state.monthlyfcprimarydata.length > 0 ?

                                this.state.monthlyfcprimarydata.map(item =>
                                    <div className={"col-xl-12 col-lg-12 row " + (this.state.shownormalprimary)}>
                                        <TransitLineChart
                                            title={"Monthly Force Closure Summary (Primary)"}
                                            subtitle={""}
                                            context={this}
                                            series={item.lineseries}
                                            categories={item.categories}
                                            xaxistitle={"Month-Year"}
                                            yaxistitle={"Clouser type (%)"}
                                            dept_code={this.state.dept_code}
                                        />
                                    </div>
                                )
                                : ""}
                            {this.state.monthlyfcsecondarydata.length > 0 ?
                                this.state.monthlyfcsecondarydata.map(item =>
                                    <div className={"col-xl-12 col-lg-12 row " + (this.state.shownormalsecond)}>
                                        <TransitLineChart
                                            title={"Monthly Force Closure Summary (Secondary)"}
                                            subtitle={""}
                                            context={this}
                                            series={item.lineseries}
                                            categories={item.categories}
                                            xaxistitle={"Month-Year"}
                                            yaxistitle={"Clouser type (%)"}
                                            dept_code={this.state.dept_code}
                                        />
                                    </div>
                                )
                                : ""} */}
                                        </div>

                                    </div>
                                    <div className={"dataLoadpage " + (this.state.loadshow)}></div>
                                    <div className={"dataLoadpageimg " + (this.state.loadshow)}>
                                        <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                                    </div>
                                    <div className={"overlay " + (this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>

                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>

        );
    }
}

function groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}


function GetSortOrder(prop) {
    return function (a, b) {
        if (a[prop] > b[prop]) {
            return 1;
        } else if (a[prop] < b[prop]) {
            return -1;
        }
        return 0;
    }
}

function GetSortDescOrder(prop) {
    return function (a, b) {
        if (a[prop] < b[prop]) {
            return 1;
        } else if (a[prop] > b[prop]) {
            return -1;
        }
        return 0;
    }
}


$(document).ready(function () {

    $(".loadclick").click(function () {
        var id = $(this).attr("id");
        $(".loadclick").removeClass("active");
        $("#" + id).addClass("active");
    })
})



function dateComparator(date1, date2) {
    // console.log("dateComparator");
    // console.log(date1.length);
    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
        // console.log(date1,date2);
        var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
        date1 = date1.replace(date1.split(" ")[0].split("-")[1], date_1);
        var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
        date2 = date2.replace(date2.split(" ")[0].split("-")[1], date_2);
        // console.log(date1,date2);
        var date1Number = monthToComparableNumber(date1);
        var date2Number = monthToComparableNumber(date2);
        // console.log(date1Number,date2Number);
        if (date1Number === null && date2Number === null) {
            return 0;
        }
        if (date1Number === null) {
            return -1;
        }
        if (date2Number === null) {
            return 1;
        }
        return date1Number - date2Number;
    }
}
function monthToComparableNumber(date) {
    // console.log(date,date.length);
    if (date === undefined || date === null || date.length !== 16) {
        return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    // console.log(yearNumber,monthNumber,dayNumber);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
}

function getMonthNumber(monthName) {
    var months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May',
        'Jun', 'Jul', 'Aug', 'Sep',
        'Oct', 'Nov', 'Dec'
    ];
    var monthNum = months.indexOf(monthName) + 1;
    if (monthNum < 10) {
        monthNum = "0" + monthNum.toString();
    }
    return monthNum;
}

function sortMonthYear(data) {
    const monthOrder = { January: 1, February: 2, March: 3, April: 4, May: 5, June: 6, July: 7, August: 8, September: 9, October: 10, November: 11, December: 12 };
    // Sorting function
    data = JSON.parse(JSON.stringify(data))
    data.sort((a, b) => {
        if (a.invoice_gate_out_year != b.invoice_gate_out_year) {
            return a.invoice_gate_out_year - b.invoice_gate_out_year; // Sort by year
        }
        return monthOrder[a.invoice_gate_out_month] - monthOrder[b.invoice_gate_out_month]; // Sort by month
    })
    return data
}